export default "__VITE_ASSET__D7yeo4aG__"